export const CTS_STYLE_ID = "cts-draw-point-sl";
export const CTS_SOURCE = "project-layers";

// Collaboration Cost to Serve layer information
export const COLLABORATION_SOURCE_LAYER = "service_location";
export const COLLABORATION_LAYER_FILTER = undefined;

// NBN Cost to Serve layer information
export const NBN_SOURCE_LAYER = "input_layers/cabling/sl";
export const NBN_SOURCE_LAYER_FILTER = ["==", ["get", "project_code"], "N2P-MOD"];
